import React, {useCallback, useState, useEffect} from 'react';
import {connect} from 'react-redux';
import ConditionedComponent from 'components/ConditionedComponent.js';
import VolumeBox from './VolumeBox.js';
import Colors from 'components/Colors.js';

const colors = new Colors();

const TrackSlot = ({showMods, name, rackTrack, track, onSelect, isSelected, onDelete, id}) => {
    let className = 'track-slot';
    let style = {
    };
    if (isSelected) {
        className += ' selected';
        style['backgroundColor'] = colors.getColorForTrack(track.track);
    }
    if (name.length > 16) {
        name = name.substring(0, 16) + '...';
    }

    return (
        <div
          onClick={onSelect}
          className={className}
          style={style}
        >
          <div className="sub-instrument-name">
            {name}
          </div>
          <VolumeBox rackTrack={rackTrack} track={track}/>
          <ConditionedComponent condition={isSelected}>
            <div
              onClick={onDelete}
              className="delete-button">x</div>
          </ConditionedComponent>
        </div>
    );
}
 
const mapStateToProps = (state, props) => {
    let track = props.track.track;
    return {
        id: track.sample !== undefined && track.sample.getId() !== undefined ?
                track.sample.getId() : track.presetName || track.getName()
    };
};

export default connect(mapStateToProps, null)(TrackSlot);
